import heroMapping from '../components/heroMapping';
import freeTextMapping from '../components/freeTextMapping';

const miscPageMapping = (data) => {
    const mappedData = {};
    let components = data.data.relationships.field_components.data;

    mappedData.hero = heroMapping(components.find(component => {
        return component.type === "paragraph--hero_carousel_component"
    }));
    mappedData.freeText = freeTextMapping(components.find(component => {
        return component.type === "paragraph--free_text_component"
    }));
    return mappedData;
};


export default miscPageMapping;
